import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { ROUTES, getButtonLinkProps } from '@openclassrooms/routing';
import { translate } from '@openclassrooms/translations';
import { styled } from '@classify/react-core-components/styles';
import Stack from '@classify/react-core-components/Stack';
import Button from '@classify/react-core-components/Button';
import Box from '@classify/react-core-components/Box';
import Typography from '@classify/react-core-components/Typography';
import BulletPoint from '@classify/react-core-components/BulletPoint';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import { ToolIcon } from '@openclassrooms/common-app/customIcons';
import imgSrc from './images/jobposting_ai_image.png';
const BulletList = styled('ul')(({
  theme: {
    spacing
  }
}) => ({
  margin: 0,
  padding: 0,
  '& > li': {
    display: 'flex',
    margin: 0,
    '&:not(:last-child)': {
      marginBottom: spacing(2)
    }
  }
}));
const AiBorder = styled('div')(({
  theme: {
    spacing,
    palette
  }
}) => {
  const bgColor = palette.layout.background.alternative;
  return {
    containerType: 'inline-size',
    background: `linear-gradient(${bgColor}, ${bgColor}) padding-box, ${palette.brand.gradient.pinkViolet} border-box`,
    border: `4px solid transparent`,
    borderRadius: spacing(1)
  };
});
const ImageContainer = styled('div')(({
  theme: {
    containerQueries
  }
}) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  justifyContent: 'center',
  '> img': {
    width: 300,
    height: 'auto',
    alignSelf: 'center'
  },
  [containerQueries.up('sm')]: {
    flexDirection: 'row',
    '> img': {
      width: 400,
      alignSelf: 'flex-end'
    }
  },
  [containerQueries.up('md')]: {
    '> img': {
      width: 500,
      height: 'fit-content'
    }
  }
}));
const InnerWrapper = styled('div')(({
  theme: {
    containerQueries
  }
}) => ({
  display: 'flex',
  flexDirection: 'column',
  [containerQueries.up('sm')]: {
    flexDirection: 'row'
  }
}));
const TextWrapper = styled(Box)(({
  theme: {
    spacing,
    containerQueries
  }
}) => ({
  flexGrow: 1,
  padding: spacing(2, 0, 2, 2),
  [containerQueries.up('sm')]: {
    padding: spacing(4, 0, 4, 4)
  }
}));
export default function JobOfferBanner() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Typography variant="h4" sx={{
      mb: 2
    }}>{translate("job_market_place.offer_service.title")}</Typography>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <BulletPoint marker={AutoAwesomeIcon}>{translate("job_market_place.apprenticeship.uvp_ai.bullet")}</BulletPoint>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <BulletPoint marker={ToolIcon}>{translate("job_market_place.apprenticeship.uvp_tool.bullet")}</BulletPoint>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <BulletList>{t1}{t2}<BulletPoint marker={ListAltRoundedIcon}>{translate("job_market_place.apprenticeship.uvp_offers.bullet")}</BulletPoint></BulletList>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      marginTop: 3
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = getButtonLinkProps(`${ROUTES.JOB_POSTINGS.INDEX}/apprenticeship`);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TextWrapper>{t0}{t3}<Stack direction="row" gap={2} sx={t4}><Button {...t5} variant="secondary" data-event="Navigation|Redirection::Internal|Job offers preview access">{translate("global.see_job_offers.cta")}</Button></Stack></TextWrapper>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <AiBorder><InnerWrapper>{t6}<ImageContainer><Image src={imgSrc} alt="" width={500} /></ImageContainer></InnerWrapper></AiBorder>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}